import React, { useEffect } from "react";
import { CssBaseline, Box, Grid } from "@mui/material";
import Newsidebar from "../components/shared/newsidebar";
import "../components/home/home.style.css";
import Newheader from "../components/shared/newheader";
import MetaDecorator from "../services/meta_decorator";
//import { useStyles } from "../style";
import InactivityMeter from "../components/shared/inactivitymeter";
import Footer from "../components/shared/footer";
import { bodyBg2, footerContainer, fullHeight, paddingbox } from "../style2";

// function NotificationItem({ text, date }) {
//   return (
//     <Paper 
//     elevation={2} 
//     style={{ 
//       height: '80px', 
//       padding: "12px", 
//       borderBottom: '1px solid #e0e0e0'
//     }}
//   >
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Typography variant="body1">{text}</Typography>
//         <Typography variant="caption" color="textSecondary">
//           {date}
//         </Typography>
//       </Box>
//     </Paper>
//   );
// }

function Newnotification() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //const classes = useStyles();

  // const notifications = [
  //   {
  //     text: "Alison Morgan shared a report with Katie Holmes",
  //     date: "23/06/23 14.30",
  //   },
  //   {
  //     text: "Katie Holmes shared a report with Alison Morgan",
  //     date: "03/05/23 10.17",
  //   },
  //   {
  //     text: "Alison Morgan shared a report with Katie Holmes",
  //     date: "23/06/23 14.30",
  //   },
  //   {
  //     text: "Katie Holmes shared a report with Alison Morgan",
  //     date: "03/05/23 10.17",
  //   },
  //   {
  //     text: "Alison Morgan shared a report with Katie Holmes",
  //     date: "23/06/23 14.30",
  //   },
  //   {
  //     text: "Katie Holmes shared a report with Alison Morgan",
  //     date: "03/05/23 10.17",
  //   },
  //   {
  //     text: "Alison Morgan shared a report with Katie Holmes",
  //     date: "23/06/23 14.30",
  //   },
  //   {
  //     text: "Katie Holmes shared a report with Alison Morgan",
  //     date: "03/05/23 10.17",
  //   },
  //   {
  //     text: "Alison Morgan shared a report with Katie Holmes",
  //     date: "23/06/23 14.30",
  //   },
  //   {
  //     text: "Katie Holmes shared a report with Alison Morgan",
  //     date: "03/05/23 10.17",
  //   },
  // ];

  //const [page, setPage] = useState(1);
  //const itemsPerPage = 6;

  //const totalPageCount = Math.ceil(notifications.length / itemsPerPage);
  //const maxPages = 5; 

  // const handlePageChange = (event, value) => {
  //   setPage(value);
  // };

  return (
    <Box sx={{ ...bodyBg2, ...fullHeight }}>
      <CssBaseline />
      <MetaDecorator
        title={"EnrichMyCare - Notification"}
        description={"Professional dashboard app"}
      />
      <Newsidebar />
      <Newheader show_profile_button={true} />
      <Box mt={12} />
      <Box sx={paddingbox}>
        <Grid container justify="center" sx={paddingbox}>
          <Grid item xs={12} sm={12} lg={10}>
            <Box p={3}>
              {/* <Typography
                variant="h6"
                className={classes.dashboardText}
                style={{ marginBottom: "20px" }}
              >
                Notifications
              </Typography> */}
              <Box m={2} />
              <Box sx={{ backgroundColor: "#fff", padding: "20px", fontSize: "2rem", textAlign: "center" }}>
                Coming Soon
              </Box>
              {/* {notifications
                .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                .map((notification, index) => (
                  <NotificationItem
                    key={index}
                    text={notification.text}
                    date={notification.date}
                  />
                ))} */}
            </Box>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Pagination
              count={totalPageCount > maxPages ? maxPages : totalPageCount}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              color="primary"
              className={classes.pagination}
              boundaryCount={maxPages}
            />
          </Box>
        </Grid> */}
      </Box>
      <InactivityMeter />
      <Box style={footerContainer}>
        <Footer />
      </Box>
    </Box>
  );
}

export default Newnotification;
